if (!customElements.get('key-info-popup')) {
  customElements.define(
    'key-info-popup',
    class KeyInfoPopup extends HTMLElement {
      constructor() {
        super();
        this.mobileTrigger = this.querySelector('.key__features');
        this.popupOverlay = this.querySelector('.key-info-popup__overlay');
        this.popupPanel = this.querySelector('.key-info-popup__panel');
        this.closeBtn = this.querySelector('.key-info-popup__close');
        this.swipeHandle = this.querySelector('.key-info-popup__header');
        this.controller = null;
        this.isMobile = window.matchMedia('(max-width: 749px)').matches;
        this.onMobileTriggerKeydown = this.onMobileTriggerKeydown.bind(this);
      }

      onMobileTriggerKeydown(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        event.preventDefault();
        this.controller?.open();
      }

      connectedCallback() {
        const init = () => {
          if (this.isMobile) {
            this.mobileTrigger?.setAttribute('role', 'button');
            this.mobileTrigger?.setAttribute('tabindex', '0');
            this.mobileTrigger?.setAttribute('aria-haspopup', 'dialog');
            this.mobileTrigger?.addEventListener('keydown', this.onMobileTriggerKeydown);

            this.controller = window.createBacksheetController({
              host: this,
              overlay: this.popupOverlay,
              panel: this.popupPanel,
              closeBtn: this.closeBtn,
              swipeHandle: this.swipeHandle,
              openTriggers: this.mobileTrigger ? [this.mobileTrigger] : [],
              visibleClass: 'is-visible',
              moveBackDelay: 300,
            });
            this.controller.bind();
          } else {
            this.mobileTrigger?.removeAttribute('role');
            this.mobileTrigger?.removeAttribute('tabindex');
            this.mobileTrigger?.removeAttribute('aria-haspopup');
            this.mobileTrigger?.removeEventListener('keydown', this.onMobileTriggerKeydown);
          }
        };

        // Initialise once DOM is fully loaded
        document.readyState === 'loading'
          ? document.addEventListener('DOMContentLoaded', init, { once: true })
          : init();
      }

      disconnectedCallback() {
        this.mobileTrigger?.removeEventListener('keydown', this.onMobileTriggerKeydown);
        this.controller?.unbind();
      }
    },
  );
}
